/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js/dist/zone';  // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
import '@webcomponents/webcomponentsjs/webcomponents-loader.js';
import * as Redux from 'redux';
(window as any).Redux = Redux;
import 'tangy-form/tangy-form.js'
import 'tangy-form/input/tangy-box.js'
import 'tangy-form/input/tangy-gate.js'
import 'tangy-form/input/tangy-input.js'
import 'tangy-form/input/tangy-keyboard-input.js'
import 'tangy-form/input/tangy-timed.js'
import 'tangy-form/input/tangy-untimed-grid.js'
import 'tangy-form/input/tangy-checkbox.js'
import 'tangy-form/input/tangy-checkboxes.js'
import 'tangy-form/input/tangy-checkboxes-dynamic.js'
import 'tangy-form/input/tangy-radio-buttons.js'
import 'tangy-form/input/tangy-select.js'
import 'tangy-form/input/tangy-location.js'
import 'tangy-form/input/tangy-gps.js'
import 'tangy-form/input/tangy-acasi.js';
import 'tangy-form/input/tangy-eftouch.js';
import 'tangy-form/input/tangy-photo-capture.js';
import 'tangy-form/input/tangy-qr.js';
import 'tangy-form/input/tangy-consent.js';
import 'tangy-form/input/tangy-partial-date.js';
import 'tangy-form/input/tangy-ethio-date.js';
import 'tangy-form/input/tangy-signature.js';
import 'tangy-form/input/tangy-toggle.js';
import 'tangy-form/input/tangy-radio-blocks.js';
import 'tangy-form/input/tangy-video-capture.js';
import 'tangy-form/input/tangy-prompt-box.js';
import 'tangy-form/input/tangy-audio-recording.js';
import 'tangy-form/input/tangy-audio-playback.js';

import 'translation-web-component/t-select.js'

import { Loc } from 'tangy-form/util/loc.js';
(window as any).Loc = Loc;
